/**
 * 系统下拉列表接口
 */

import request from '@/utils/request'

//获取未设置审批流物业公司员工下拉列表
export const notSetWorkFlowStaffUserDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/notSetWorkFlowStaffUserDropList`, method: 'post', data })

//获取未设置审批流项目下拉列表
export const notSetWorkFlowCommunityDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/notSetWorkFlowCommunityDropList`, method: 'post', data })

// 获取权限项目
export const permissionCommunityDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/permissionCommunityDropList`, method: 'post', data })

// 获取省份
export const areaProvinceDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/areaProvinceDropList`, method: 'post', data })

// 获取市、区、县
export const areaChildrenDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/areaChildrenDropList`, method: 'post', data })

// 获取物业公司或街道下拉列表
export const organizationDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/organizationDropList`, method: 'post', data })

// 获取公司部门
export const departmentDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/departmentDropList`, method: 'post', data })

// 获取公司全部员工
export const staffDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/staffDropList`, method: 'post', data })

//获取审批流 全部员工
export const staffDropListByTenant = (data = {}) => request({ url: `/api/estate/v1/dropList/staffDropListByTenant`, method: 'post', data })

//获取物业公司全部项目
export const allCommunityDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/allCommunityDropList`, method: 'post', data })

//获取物业公司全部角色
export const roleDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/roleDropList`, method: 'post', data })

//获取请假类型
export const vacationTypeList = (data = {}) => request({ url: `/api/estate/v1/dropList/vacationTypeList`, method: 'post', data })

// 获取全部初始化权限实体下拉列表
export const initialPermissionEntityDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/initialPermissionEntityDropList`, method: 'post', data })

//获取权限模块
export const initialPermissionModularDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/initialPermissionModularDropList`, method: 'post', data })

//获取工单分类
export const worksheetCategoryDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/worksheetCategoryDropList`, method: 'post', data })

//获取客服线路
export const callLineDropList = (data = {}) => request({ url: `/api/iot/v1/dropList/callLineDropList`, method: 'post', data })

//使用房屋编号或手机号查询房屋下拉列表
export const buildingRoomDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/buildingRoomDropList`, method: 'post', data })

//获取某个项目全部楼栋下拉列表
export const buildingDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/buildingDropList`, method: 'post', data })

//获取某个楼栋全部单元下拉列表
export const buildingUnitDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/buildingUnitDropList`, method: 'post', data })

//获取某个楼栋全部楼层下拉列表
export const buildingFloorDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/buildingFloorDropList`, method: 'post', data })

//获取设备分类下拉列表
export const deviceCategoryDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/deviceCategoryDropList`, method: 'post', data })

//获取未配置收款方式项目下拉列表
export const payTypeCommunityDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/payTypeCommunityDropList`, method: 'post', data })

//获取收费科目下拉列表
export const chargeItemDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/chargeItemDropList`, method: 'post', data })

//获取全部报销类别下拉列表
export const reimbursementTypeDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/reimbursementTypeDropList`, method: 'post', data })

//获取车位类型下拉列表
export const parkingSpaceCategoryDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/parkingSpaceCategoryDropList`, method: 'post', data })

//获取车位编号或手机号或车牌号查询车位下拉列表
export const parkingSpaceDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/parkingSpaceDropList`, method: 'post', data })

//获取项目下车场下拉列表
export const parkingDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/parkingDropList`, method: 'post', data })

//获取物资分类下拉列表
export const materialCategoryDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/materialCategoryDropList`, method: 'post', data })

//获取仓库下拉列表
export const warehouseDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/getWarehouseDropList`, method: 'post', data })

//根据物资分类获取物资下拉列表
export const materialDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/materialDropList`, method: 'post', data })

//根据仓库获取物资下拉列表
export const materialByWarehouseDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/materialByWarehouseDropList`, method: 'post', data })

//获取设备列表下拉列表
export const deviceDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/deviceDropList`, method: 'post', data })

//获取考勤班次下拉列表
export const workHoursDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/workHoursDropList`, method: 'post', data })

//获取未设置考勤规则员工下拉列表
export const notSetAttendanceRuleStaffUserDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/notSetAttendanceRuleStaffUserDropList`, method: 'post', data })

//使用姓名或手机号查询住户下拉列表
export const householdDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/householdDropList`, method: 'post', data })

//获取车牌下拉列表
export const carCodeDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/carCodeDropList`, method: 'post', data })

//获取物业科下拉列表
export const getGovernmentDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/getGovernmentDropList`, method: 'post', data })

//获取物业科（项目）下拉列表
export const communityGetGovernmentDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/communityGetGovernmentDropList`, method: 'post', data })

//获取物业科获取公司列表
export const supervisionGetOrganizationDropList = (data = {}) => request({ url: `/api/iot/v1/dropList/supervisionGetOrganizationDropList`, method: 'post', data })

//获取物业科获取项目列表
export const supervisionGetCommunityDropList = (data = {}) => request({ url: `/api/iot/v1/dropList/supervisionGetCommunityDropList`, method: 'post', data })

// 获取具有数据权限的物业公司列表
export const getDataPermissionOrganizationDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/getDataPermissionOrganizationDropList`, method: 'post', data })

// 集团项目权限树形列表
export const getDataPermissionCommunityDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/getDataPermissionCommunityDropList`, method: 'post', data })

// 集团人员权限树形列表
export const staffGroupCompanyUserDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/staffGroupCompanyUserDropList`, method: 'post', data })

// 集团未被审批流选过的项目树形列表
export const getNotSetWorkFlowCommunityDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/getNotSetWorkFlowCommunityDropList`, method: 'post', data })

// 集团未被审批流选过的员工树形列表
export const notSetGroupCompanyWorkFlowStaffUserDropList = (data = {}) =>
  request({ url: `/api/estate/v1/dropList/notSetGroupCompanyWorkFlowStaffUserDropList`, method: 'post', data })

// 集团所属部门下拉列表
export const groupCompanyDepartmentDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/groupCompanyDepartmentDropList`, method: 'post', data })

// 公司及包含项目列表
export const dataPermissionConfigDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/dataPermissionConfigDropList`, method: 'post', data })

//人员管理包含项目列表
export const oaManageCommunityDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/oaManageCommunityDropList`, method: 'post', data })

// 大后台管理账号公司下拉列表
export const getCustomDataPermissionOrganizationDropList = (data = {}) => request({ url: `/dropList/getCustomDataPermissionOrganizationDropList`, method: 'post', data })

// 押金收费科目下拉列表
export const depositDropList = (data = {}) => request({ url: `/api/estate/v1/renovation/depositDropList`, method: 'post', data })

// 一次性收费科目下拉列表
export const onceDropList = (data = {}) => request({ url: `/api/estate/v1/renovation/onceDropList`, method: 'post', data })

// 监控通道下拉列表
export const monitorChannelDropList = (data = {}) => request({ url: `/api/iot/v1/dropList/monitorChannelDropList`, method: 'post', data })

//内部通知,部门下拉列表
export const noticeDepartmentDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/noticeDepartmentDropList`, method: 'post', data })

// 获取所有租户下拉列表
export const tenantDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/tenantDropList`, method: 'post', data })

// 权限控制楼层下拉列表
export const permissionFloorDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/permissionFloorDropList`, method: 'post', data })

// 业务办理查询
export const businessProcessingDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/businessProcessingDropList`, method: 'post', data })

// 根据小区过滤收费科目
export const chargeItemPackageDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/chargeItemPackageDropList`, method: 'post', data })

// 根据车位获取关联的收费标准
export const getParkingMonthlyRentalChargeCriterionDropList = (data = {}) =>
  request({ url: `/api/estate/v1/dropList/getParkingMonthlyRentalChargeCriterionDropList`, method: 'post', data })

//获取停车场门禁设备
export const parkGateDevicesDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/parkGateDevicesDropList`, method: 'post', data })

//获取应用名称下拉
export const permissionAppDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/permissionAppDropList`, method: 'post', data })

//获取科目的收费标准
export const chargeCriterionDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/chargeCriterionDropList`, method: 'post', data })

//获取获取子公司+总公司员工
export const staffSubsidiaryApprovalUserDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/staffSubsidiaryApprovalUserDropList`, method: 'post', data })

//获取用户有权限的角色
export const permissionRoleDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/permissionRoleDropList`, method: 'post', data })

//获取车牌照
export const carIdAndCodeDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/carIdAndCodeDropList`, method: 'post', data })

// 获取设备模板
export const deviceQuestionTemplateDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/deviceQuestionTemplateDropList`, method: 'post', data })

//养护计划名下拉列表
export const onservationPlanNameDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/onservationPlanNameDropList`, method: 'post', data })

// 级别下拉列表
export const postRankDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/postRankDropList`, method: 'post', data })

//级别档次下拉列表
export const postRankGradeDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/postRankGradeDropList`, method: 'post', data })

// 获取预存或押金收费科目下拉列表
export const depositOrPreItemDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/depositOrPreItemDropList`, method: 'post', data })
// 获取当前人员拥有的公司的下拉列表
export const getCurrentStaffOrganizationDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/getCurrentStaffOrganizationDropList`, method: 'post', data })

// 根据公司获取下级部门
export const getDepartmentByOrganizationDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/getDepartmentByOrganizationDropList`, method: 'post', data })
//收据模板下拉列表
export const receiptTemplateDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/receiptTemplateDropList`, method: 'post', data })

//(部门添加时)上级部门下拉列表
export const parentDepartmentDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/parentDepartmentDropList`, method: 'post', data })

// (部门添加时)关联下拉列表
export const relateOrganizationDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/relateOrganizationDropList`, method: 'post', data })

//(部门添加时)关联主管部门下拉列表
export const relateSystemStaffDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/relateSystemStaffDropList`, method: 'post', data })

//(员工)所属部门下拉列表(转岗要员工ID)
export const staffNewDepartmentDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/staffNewDepartmentDropList`, method: 'post', data })

// (员工列表部门筛选)部门下拉列表 人员列表 搜索用
export const staffListDepartmentDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/staffListDepartmentDropList`, method: 'post', data })

//(合并/拆分)楼栋/房间下拉列表
export const mergeOrSpiltBuildingRoomDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/mergeOrSpiltBuildingRoomDropList`, method: 'post', data })

// (租赁合同新增)房屋下拉列表
export const rentContractBuildingRoomDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/rentContractBuildingRoomDropList`, method: 'post', data })

// (租赁合同新增)车位下拉列表
export const parkingSpaceTree = (data = {}) => request({ url: `/api/estate/v1/dropList/parkingSpaceTree`, method: 'post', data })

// (租赁合同新增)乙方人员下拉列表
export const rentContractCustomerDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/rentContractCustomerDropList`, method: 'post', data })

// (租赁合同新增)收费标准回显下拉列表
export const rentContractChargeCriterionDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/rentContractChargeCriterionDropList`, method: 'post', data })

// 使用姓名或手机号查询商业客户下拉列表
export const commerceHouseholdDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/commerceHouseholdDropList`, method: 'post', data })

// 仪表下拉列表
export const meterDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/meterDropList`, method: 'post', data })

// 打卡缺勤记录下拉列表
export const missCardShiftDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/missCardShiftDropList`, method: 'post', data })

// 获取具有权限的费项列表
export const incomeTitleDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/incomeTitleDropList`, method: 'post', data })

// 视频菜单下拉列表
export const introductionVideoMenuDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/introductionVideoMenuDropList`, method: 'post', data })

// 投诉配置-投诉分类下拉列表
export const complainCateDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/complainCateDropList`, method: 'post', data })

// 投诉记录-投诉分类下拉列表
export const complainCategoryDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/complainCategoryDropList`, method: 'post', data })

// 合同缴费
export const contractBusinessDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/contractBusinessDropList`, method: 'post', data })

// 获取公司税号列表
export const invoiceCompanyDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/invoiceCompanyDropList`, method: 'post', data })

// 获取公司税号分类列表
export const taxCategoryDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/taxCategoryDropList`, method: 'post', data })

// 获取公司税号全部列表
export const invoiceALLCompanyDropList = (data = {}) => request({ url: `/api/estate/v1/dropList/invoiceALLCompanyDropList`, method: 'post', data })
